import React from 'react';

const Abril2025_reportes = () => {
  // Función genérica para hacer scroll sin tocar el URL
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="scroll-smooth11">
        <h1 className="text-4xl font-bold mb-4">Novedades en REPORTES</h1>

        <p className="text-base text-gray-600 mb-1">Feature Updates</p>
        <p className="text-base text-gray-500 mb-6">
          Fecha de lanzamiento: <span className="font-semibold text-gray-700">Abril 2025</span>
        </p>

        {/* Índice de contenidos */}
        <ul className="list-disc list-inside mb-8 marker:text-black text-red-600 space-y-2">
          <li
            onClick={() => scrollToId('ajuste-reporte-categorias')}
            className="cursor-pointer hover:text-red-800"
          >
            Ajuste en Reporte de Categorías
          </li>
          {/* <li
            onClick={() => scrollToId('correos-fin-de-dia')}
            className="cursor-pointer hover:text-red-800"
          >
            Correos fin de día
          </li> */}
          <li
            onClick={() => scrollToId('reporte-tasa-cambio')}
            className="cursor-pointer hover:text-red-800"
          >
            Reporte de Tasa de cambio
          </li>
        </ul>


        <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
        <h2 id="ajuste-reporte-categorias" className="text-3xl font-semibold mb-4">
          1. Ajuste en Reporte de Categorías
        </h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Hemos actualizado el Reporte de Categorías para que el subtotal ahora muestre los montos después de aplicar descuentos, alineándolo con el Reporte Z. 
            Esto no afecta los valores reales, simplemente cambia la forma en que se presentan en este reporte específico.
          </p>
          <h3 className="text-xl font-bold mb-4 mt-6">Beneficios:</h3>
          <ul className="list-disc list-inside mb-6 text-lg">
            <li>Información más clara y coherente entre reportes</li>
            <li>Mejor control financiero y auditoría interna</li>
          </ul>
        </div>
        
        {/* <span class="inline-flex items-center rounded-md bg-red-50 px-4 py-1 text-md font-medium text-red-700 ring-1 ring-red-600/10 ring-inset mb-5">Correción</span>
        <h2 id="correos-fin-de-dia" className="text-3xl font-semibold mb-4">
          2. Correos fin de día
        </h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Se solucionó un problema que impedía el envío correcto de correos automáticos de cierre de día para algunos clientes. 
            Ahora los correos se envían de forma confiable según la hora de cierre configurada.
          </p>
        </div> */}

        <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
        <h2 id="reporte-tasa-cambio" className="text-3xl font-semibold mb-4">
          2. Reporte de Tasa de cambio
        </h2>
        <div className="mb-12">
          <p className="mb-4 text-gray-700 leading-relaxed text-lg">
            Se agregó un reporte para consultar la tasa de cambio utilizada en operaciones en moneda extranjera.
          </p>
          <img
            src="https://img.invupos.com/webinvu/Software%20release/Products/Admin/Reportes/3.png"
            alt="Reporte de Tasa de cambio"
            className="w-3/4 object-cover rounded-2xl border border-3"
          />
        </div>
      </div>
    </>
  );
};

export default Abril2025_reportes;